import { get, post } from '@/api/axiosprovider';
import { IRegion, IRegionCampaign, IRegionCampaignUpdate } from '@/models';

const getRegionCampaigns = async (
	request: IRegion
): Promise<IRegionCampaign> => {
	return await get(
		`/api/settings/regioncampaigns/${request.company}/${request.businessUnit}/${request.serviceRegion}`
	);
};

const getAllRegionRegionCampaigns = async (): Promise<IRegionCampaign[]> => {
	return await get('/api/settings/regioncampaigns');
};

const postRegionCampaigns = async (
	request: IRegionCampaignUpdate[]
): Promise<void> => {
	return await post<IRegionCampaignUpdate[], void>(
		'/api/settings/regioncampaigns/',
		request
	);
};

export const regionCampaignsController = {
	getRegionCampaigns,
	getAllRegionRegionCampaigns,
	postRegionCampaigns
};
